<template>
  <div>
    <div class="header">
      <div class="changeBut">
        <span :class="{ ButActive: ButFlag1 == true }"
          @click="() => {ButFlag1 = true;}">生意概况</span>
        <span :class="{ ButActive: ButFlag1 == false }"
          @click="() => {ButFlag1 = false;}">搜索词占比</span>
      </div>
      <div class="selList">
        <van-dropdown-menu active-color="#CC4545">
          <van-dropdown-item v-model="value" :options="option1" />
        </van-dropdown-menu>
        <el-date-picker
          v-model="value1"
          :type="type"
          size="mini"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          popper-class="date-style"
        >
        </el-date-picker>
      </div>
      <div v-if="ButFlag1" class="JingTie">
        <div class="JingTieTop">
          <p>GMV</p>
          <b>1000</b>
          <i>vs.LY</i>
          <span>29%</span>
        </div>
        <ul class="JintTieList">
          <li class="JintTieListAct"></li><span>X</span>
          <li></li><span>X</span>
          <li></li>
        </ul>
      </div>
    </div>
    <BenSearch v-if="ButFlag1 == false"></BenSearch>
    <BenBusiness v-else></BenBusiness>
  </div>
</template>
<script>
import BenSearch from "./BenSerach";
import BenBusiness from "./BenBusiness";
export default {
  data() {
    return {
      option1: [
        { text: "全部商品", value: 0 },
        { text: "新款商品", value: 1 },
        { text: "活动商品", value: 2 },
      ],
      value: 0,
      type: "monthrange",
      value1: "",
      state2: "",
      ButFlag1: true,
    };
  },
  methods: {
    handleSelect(item) {
      console.log(item);
    },
    handleIconClick(ev) {
      console.log(ev);
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
  },
  components: { BenSearch ,BenBusiness},
};
</script>
<style scoped>
.header {
  background: rgb(224, 68, 60);
  padding-bottom: 20px;
}

.changeBut {
  margin: auto 20px;
  width: 41%;
  display: flex;
  height: 29px;
  line-height: 29px;
  border-radius: 20px;
  background-color: rgb(206, 53, 44);
  color: #ccc;
  box-shadow: inset 1px 1px 2px black;
}
.changeBut > span {
  text-align: center;
  display: inline-block;
  width: 50%;
  height: 100%;
  border-radius: 20px;
}
.ButActive {
  background-color: rgb(255, 116, 95);
  color: #fff;
}
.selList {
  width: 91%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
}
.van-dropdown-menu {
  margin-right: 28px;
  z-index: 5;
  background: rgb(255, 116, 95) !important;
  box-shadow: 0 3px 8px 0 rgba(204, 69, 69, 0.3);
  width: 45%;
  height: 30px;
  border-radius: 15px;
}
/deep/ .van-hairline--top-bottom::after {
  border: none !important;
}
/deep/ .van-popup--top {
  width: 36.7%;
  background: rgba(209, 87, 87, 0.9);
  border-radius: 5%;
  left: 2.6%;
  top: 2px;
}
/deep/ .van-overlay {
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-cell__value {
  display: none;
}
/deep/ .van-cell__title {
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #ffffff;
}
/deep/ .van-cell {
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-ellipsis {
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  color: #ffffff;
}
/deep/ .van-dropdown-menu__title::after {
  border-color: transparent transparent #cc4545 #cc4545;
}
/deep/ .van-dropdown-item__content {
  max-height: 55%;
}
/deep/ .date-style .el-picker-panel {
  color: #cc4545 !important;
}
.JingTie {
  padding: 20px;
}
.JingTieTop {
  width: 65%;
  height: 40px;
  line-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.JingTieTop p {
  font-size: 18px;
  color: rgb(252, 241, 241);
}
.JingTieTop b {
  font-size: 30px;
  color: #fff;
}
.JingTieTop i {
  font-size: 18px;
  color: rgb(252, 241, 241);
}
.JingTieTop span {
  color: rgb(255, 249, 52);
  font-size: 30px;
}
.JintTieList{
  margin-top: 10px;
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
}
.JintTieList span{
  color: #fff;
}
.JintTieList li{
  height: 100px;
  width: 30%;
  border-radius: 15px;
  background-color: rgb(206, 53, 44);
}
.JintTieListAct{
  box-shadow: 0 10px 10px 0 rgba(204, 69, 69, 0.3);
  background-color: rgb(255,116,95) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ButSix_vs/VsBen/VsBen.vue